import { render, staticRenderFns } from "./MobileChat.vue?vue&type=template&id=2f10d0e4&scoped=true&"
import script from "./MobileChat.vue?vue&type=script&lang=js&"
export * from "./MobileChat.vue?vue&type=script&lang=js&"
import style0 from "./MobileChat.vue?vue&type=style&index=0&id=2f10d0e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f10d0e4",
  null
  
)

export default component.exports